import { EventData } from '~admin/model/event-data';
import { mapEventTranslationData } from '~admin/model/event-translation-data.mapper';
import { mapMediaData, mapMediaDataList } from '~admin/model/media-data.mapper';
import { EventResponse } from '~client/model/admin/event-response';

export const mapEventData = (response: EventResponse): EventData => {
  const {
    id,
    primaryClient,
    eventName,
    optionalLongDescription,
    language,
    eventLocationId,
    seatMap,
    seatConfigurationId,
    eventAccessibilityType,
    avatarMedia,
    defaultMedia,
    emailMedia,
    eventMedia,
    eventStartDate,
    eventEndDate,
    externalNotificationSubscriptions,
    facebookPixelId,
    onlineVisibleDate,
    onlineHideDate,
    doorsOpenDate,
    ticketLimit,
    currency,
    liveStreamReplaySeconds,
    vanityName,
    eventTranslations,
    eventTimelineGroups,
    eventRestrictions,
    sponsorGroups,
  } = response;

  return {
    id,
    clientId: Number(primaryClient.id),
    eventName,
    eventDescription: optionalLongDescription,
    eventLocationId: Number(eventLocationId),
    language,
    seatMap: mapMediaData(seatMap),
    seatConfigurationId,
    eventAccessibilityType,
    avatarMedia: mapMediaData(avatarMedia),
    defaultMedia: mapMediaData(defaultMedia),
    emailMedia: mapMediaData(emailMedia),
    eventMedia: mapMediaDataList(eventMedia),
    eventStartDate,
    eventEndDate,
    discoverStartDate: onlineVisibleDate,
    discoverEndDate: onlineHideDate,
    doorsOpenDate,
    ticketLimit,
    currency,
    isPrivateEvent: response.private,
    liveStreamReplay: liveStreamReplaySeconds / 60,
    vanityName,
    eventTranslations: mapEventTranslationData(eventTranslations),
    eventTimelineGroups,
    eventRestrictions,
    externalNotificationSubscriptions,
    facebookPixelId,
    sponsorGroups,
  };
};



// WEBPACK FOOTER //
// ./model/event-data.mapper.ts